const addUnit = value => /^\d*(\.\d+)?$/.test(value) ? `${value}px` : value
export default addUnit
